import { get } from "lodash";
import { Navigate, useRoutes } from "react-router-dom";
import { useAppSelector } from "../hooks/useSelector";
import DashboardLayout from "../layouts/Dashboard";
import MinimalLayout from "../layouts/Minimal";
import AccountProfilePage from "../pages/AccountProfilePage";
import ChangePasswordPage from "../pages/ChangePasswordPage";
import ContractCreate from "../pages/contract/ContractCreate";
import ContractDetail from "../pages/contract/ContractDetail";
import ContractEdit from "../pages/contract/ContractEdit";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import Dashboard from "../pages/dashboard/Dashboard";
import EmployeeDashboard from "../pages/dashboard/EmployeeDashboard";
import EmployeeDetail from "../pages/dashboard/EmployeeDetail";
import ForgotPage from "../pages/ForgotPage";
import LoadingPage from "../pages/LoadingPage";
import PageNotFound from "../pages/PageNotFound";
import SignInPage from "../pages/SignInPage";
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage";
import UserCreate from "../pages/user/UserCreate";
import UserEdit from "../pages/user/UserEdit";
import UserList from "../pages/user/UserList";
import ContractList from "../pages/contract/ContractList";
import TemplateManagement from "../pages/contract/TemplateManagement";
import ContractReviewPublic from "../pages/contract/ContractReviewPublic";

export default function Routes() {
  const { user } = useAppSelector((state) => state.global);
  const chooseDefaultRoute: any = () => {
    const role = get(user, "role_id");
    if (user?.is_admin || role === 1) {
      return { element: <Navigate to="/app/dashboard" />, index: true };
    } else if (role === 2) {
      return { element: <Navigate to="/app/employee-dashboard" />, index: true };
    }
    return { element: <LoadingPage />, index: true };
  };
  return useRoutes([
    {
      path: "/app",
      element: <DashboardLayout />,
      children: [
        {
          path: "/app",
          children: [chooseDefaultRoute()],
        },
        {
          path: "/app/profile",
          children: [
            { element: <AccountProfilePage />, index: true },
            {
              element: <ChangePasswordPage />,
              path: "/app/profile/change-password",
            },
          ],
        },
        {
          path: "/app/dashboard",
          children: [
            { element: <Dashboard />, index: true },
            {
              element: <EmployeeDetail />,
              path: "/app/dashboard/employee/:id",
            },
          ],
        },
        {
          path: "/app/employee-dashboard",
          children: [
            { element: <EmployeeDashboard />, index: true },
          ],
        },
        {
          path: "/app/users",
          children: [
            { element: <UserList />, index: true },
            {
              element: <UserCreate />,
              path: "/app/users/create-user",
            },
            {
              element: <UserEdit />,
              path: "/app/users/edit/:id",
            },
          ],
        },
        {
          path: "/app/contract",
          children: [
            { element: <ContractList />, index: true },
            {
              element: <ContractCreate />,
              path: "/app/contract/create-contract",
            },
            {
              element: <ContractEdit />,
              path: "/app/contract/edit/:id",
            },
            {
              element: <ContractDetail />,
              path: "/app/contract/detail/:id",
            },
            {
              element: <TemplateManagement />,
              path: "/app/contract/template-management",
            },
          ],
        },
        {
          path: "*",
          element: <PageNotFound fullWidth={false} />,
        },
      ],
    },
    {
      path: "/",
      element: <MinimalLayout />,
      children: [
        {
          path: "/",
          element: <SignInPage />,
        },
        {
          path: "/reset-password",
          element: <ForgotPage />,
        },
        {
          path: "/forgot-password/",
          element: <ResetPasswordPage />,
        },
        {
          path: "/privacy-policy",
          element: <PrivacyPolicyPage />,
        },
        {
          path: "/contract/review/:token",
          element: <ContractReviewPublic />,
        },
        {
          path: "*",
          element: <PageNotFound fullWidth />,
        },
      ],
    },
  ]);
}
